export interface RedeemInviteInput {
  apiBaseUrl: string;
  code: string;
  fetchFn?: typeof fetch;
}

export interface RedeemUser {
  userPublicId: string;
  role: "admin" | "office_staff" | "driver";
  name: string;
}

export type RedeemInviteResult =
  | { ok: true; user: RedeemUser }
  | { ok: false; error: string; retryAfterSec?: number };

/**
 * driver-ui (pending) から httpOnly Cookie セッションで招待コードを redeem する。
 * API の `/api/v1/invites/redeem` は session-resolver を通さず Better-Auth の raw session
 * を見る設計なので、status='pending' でも呼び出し可能。Cookie は credentials:'include' で送る。
 */
export async function redeemInviteCode(input: RedeemInviteInput): Promise<RedeemInviteResult> {
  const fetchFn = input.fetchFn ?? fetch;
  const code = input.code.trim().normalize("NFKC").toUpperCase();
  const res = await fetchFn(`${input.apiBaseUrl}/api/v1/invites/redeem`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ code }),
  });
  const body = (await res.json().catch(() => ({}))) as {
    success?: true;
    data?: RedeemUser;
    error?: string;
    retryAfterSec?: number;
  };
  if (!res.ok || !body.data) {
    return { ok: false, error: body.error ?? "REDEEM_FAILED", retryAfterSec: body.retryAfterSec };
  }
  return { ok: true, user: body.data };
}
